import ImagePageWrapper from "components/pages/ImagePageWrapper";
import { ResetPassword } from "features/System/ResetPassword";
import React from "react";
import { useParams } from "react-router-dom";

const ResetPasswordPage = () => {
  const { token } = useParams();

  return (
    <ImagePageWrapper>
      <ResetPassword token={token} />
    </ImagePageWrapper>
  );
};

export default ResetPasswordPage;
